/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useRef, useEffect, useState } from 'react';

export default function progressBarSticky() {
    const progressBarRef = useRef();
    const [isStickyHeader, setStickyHeader] = useState(false);
    const setStickyStyle = (rootElem, topOffset, isSticky) => {
        rootElem.setAttribute(
            'style',
            isSticky ? `top: ${topOffset}px; ` : 'top: 0px;',
        );
    };
    const updateStickyHeader = (header, sticky) => {
        const rootElem = document?.querySelector('#progress_bar_mobile');
        setStickyStyle(rootElem, sticky ? header.offsetHeight : 0, sticky);
    };

    const handleScroll = () => {
        if (typeof window !== 'undefined') {
            if (progressBarRef.current) {
                const { top } = progressBarRef.current.getBoundingClientRect();
                const header = document.querySelector('#global_header_container>div');
                setStickyHeader(top <= header?.offsetHeight);
                updateStickyHeader(header, top <= header?.offsetHeight);
            }
        }
    };

    useEffect(() => {
        // Add scroll event when the component is loaded
        if (typeof document !== 'undefined') {
            document.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (typeof document !== 'undefined') {
                document.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    return {
        isStickyHeader, progressBarRef,
    };
}
